import { render, staticRenderFns } from "./table-form.vue?vue&type=template&id=3603ee0e&scoped=true&"
import script from "./table-form.vue?vue&type=script&lang=js&"
export * from "./table-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3603ee0e",
  null
  
)

export default component.exports